<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-default" style="margin-bottom: 10px;">
          <div
            class="panel-heading"
            @click.prevent="collapsed = !collapsed"
            style="cursor: pointer;"
          >
            <a>
              <i class="fa" :class="{ 'fa-plus': collapsed, 'fa-minus': !collapsed }" /> Endereço
            </a>
          </div>

          <div class="row" v-if="!collapsed" style="padding-bottom: 15px;">
            <div class="col-sm-12">
              <br />
              <div class="col-sm-3">
                <div class="form-group">
                  <label for="">Município:</label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      :disabled="addressFieldsDisabled"
                      v-model="empresaSelecionada.endereco.nome"
                    />
                    <span class="input-group-btn">
                      <button
                        type="button"
                        class="btn btn-default"
                        v-btn-clipboard
                        :data-clipboard-text="empresaSelecionada.endereco.nome"
                      >
                        <i class="fa fa-clipboard"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">UF:</label>
                  <input
                    class="form-control"
                    :disabled="addressFieldsDisabled"
                    v-model="empresaSelecionada.endereco.estadoUf"
                  />
                </div>
              </div>

              <div class="col-sm-3">
                <label for="">CEP:</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    :disabled="addressFieldsDisabled"
                    v-model="empresaSelecionada.endereco.cep"
                    @keypress="onlyNumbers"
                  />
                  <span class="input-group-btn">
                    <button
                      type="button"
                      :disabled="!empresaSelecionada.endereco.cep"
                      class="btn btn-default"
                      v-btn-clipboard
                      :data-clipboard-text="empresaSelecionada.endereco.cep"
                    >
                      <i class="fa fa-clipboard"></i>
                    </button>
                  </span>
                </div>
              </div>

              <div class="col-sm-4">
                <label for="">Bairro:</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    :disabled="addressFieldsDisabled"
                    v-model="empresaSelecionada.endereco.bairro"
                  />
                  <span class="input-group-btn">
                    <button
                      type="button"
                      :disabled="!empresaSelecionada.endereco.bairro"
                      class="btn btn-default"
                      v-btn-clipboard
                      :data-clipboard-text="empresaSelecionada.endereco.bairro"
                    >
                      <i class="fa fa-clipboard"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="col-sm-4">
                <label for="">Logradouro:</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    :disabled="addressFieldsDisabled"
                    v-model="empresaSelecionada.endereco.logradouro"
                  />
                  <span class="input-group-btn">
                    <button
                      type="button"
                      :disabled="!empresaSelecionada.endereco.logradouro"
                      class="btn btn-default"
                      v-btn-clipboard
                      :data-clipboard-text="empresaSelecionada.endereco.logradouro"
                    >
                      <i class="fa fa-clipboard"></i>
                    </button>
                  </span>
                </div>
              </div>

              <div class="col-sm-2">
                <label for="">Número:</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    :disabled="addressFieldsDisabled"
                    v-model="empresaSelecionada.endereco.numero"
                  />
                  <span class="input-group-btn">
                    <button
                      type="button"
                      :disabled="!empresaSelecionada.endereco.numero"
                      class="btn btn-default"
                      v-btn-clipboard
                      :data-clipboard-text="empresaSelecionada.endereco.numero"
                    >
                      <i class="fa fa-clipboard"></i>
                    </button>
                  </span>
                </div>
              </div>

              <div class="col-sm-3">
                <label for="">Complemento:</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    :disabled="addressFieldsDisabled"
                    v-model="empresaSelecionada.endereco.complemento"
                  />
                  <span class="input-group-btn">
                    <button
                      type="button"
                      :disabled="!empresaSelecionada.endereco.complemento"
                      class="btn btn-default"
                      v-btn-clipboard
                      :data-clipboard-text="empresaSelecionada.endereco.complemento"
                    >
                      <i class="fa fa-clipboard"></i>
                    </button>
                  </span>
                </div>
              </div>

              <div class="col-sm-3">
                <label for="">Código Município:</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    :disabled="addressFieldsDisabled"
                    v-model="empresaSelecionada.endereco.id"
                    @keypress="onlyNumbers"
                  />
                  <span class="input-group-btn">
                    <button
                      type="button"
                      :disabled="!empresaSelecionada.endereco.id"
                      class="btn btn-default"
                      v-btn-clipboard
                      :data-clipboard-text="empresaSelecionada.endereco.id"
                    >
                      <i class="fa fa-clipboard"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="pull-right" style="margin: 20px 10px 5px;">
                <button
                  class="btn edit-badge"
                  style="margin-left: 5px;"
                  @click.prevent="addressFieldsDisabled = !addressFieldsDisabled"
                >
                  Editar
                </button>
                <button
                  class="btn btn-primary"
                  @click.prevent="updateAddress"
                  :disabled="addressFieldsDisabled"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmpresaService from '../../services/EmpresaService'

export default {
  name: 'edereco-box',
  data() {
    return {
      collapsed: true,
      addressFieldsDisabled: true
    }
  },

  methods: {
    onlyNumbers(event) {
      const permitido = /^[0-9]$/
      if (!permitido.test(event.key)) {
        event.preventDefault()
      }
    },

    async updateAddress() {
      try {
        await EmpresaService.updateCompanyAddress(this.queryUpdate)
        this.$messages.success().toast('Endereço atualizado com sucesso !')
        this.$emit('on-update-address')
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível atualizar o endereço.')
        console.error(e)
      } finally {
        this.addressFieldsDisabled = true
      }
    }
  },

  components: {},
  computed: {
    empresaSelecionada() {
      return this.$store.getters.getCompany
    },

    queryUpdate() {
      return {
        idEmpresa: this.empresaSelecionada.id,
        cpfCnpj: this.empresaSelecionada.cnpj,
        cidade: this.empresaSelecionada.endereco.nome,
        uf: this.empresaSelecionada.endereco.estadoUf,
        cep: this.empresaSelecionada.endereco.cep,
        bairro: this.empresaSelecionada.endereco.bairro,
        logradouro: this.empresaSelecionada.endereco.logradouro,
        numero: this.empresaSelecionada.endereco.numero,
        complemento: this.empresaSelecionada.endereco.complemento,
        codigoMunicipio: this.empresaSelecionada.endereco.id
      }
    }
  },
  watch: {}
}
</script>

<style lang="css" scoped>
a {
  color: #3c8dbc !important;
}

.edit-badge {
  background-color: #52baf7;
  font-size: 13px;
  color: white;
  padding: 1px 4px;
  border-radius: 5px;
  /* margin-right: 5px; */
  margin: 5px 5px;
  cursor: pointer;
}
</style>
